<template>
  <div>
    <input @input="handleFileAdded($event)" placeholder="Upload file..."
     class="form-control" type="file" :accept="acceptType">

    <div v-if="errorMessage" class="mt-3 alert alert-warning" role="alert">
        {{ errorMessage }}
    </div>
  </div>
</template>

<script>

export default {
    props:{
        uploadUrl:{
            type: String,
            default: "/api/uploads"
        },
        fileUploadType:{
            type: String,
            default: "image"
        },
        acceptType:{
            type: String,
            default: 'image/*'
        },
        maxSize:{
            type: Number,
            default: 2000000
        },
        includeDataUrl: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            data:{},

            errorMessage: null
        }
    },
    methods:{
        handleFileAdded($event){
            this.errorMessage = null

            let file = $event.target.files[0]
            if(file.size > this.maxSize){
                this.alertError(`File size is more than ${this.$filters.getReadableFileSize(this.maxSize)}`); return;
            }
            this.fillFileDetails(file);
            if(!this.includeDataUrl){
                this.uploadFile(file); return;
            }
            this.$filters.fileReader(file)
                .then(result => {
                    this.data.imgSrc = result.dataURL;
                    this.uploadFile(file)
                })
                .catch(error => {
                    this.alertError('Error reading file '+error);
                });
        },
        fillFileDetails(file){
            this.data.name = file.name
            this.data.type = file.type
            this.data.extension = this.$filters.getFileExtension(file.name)
            this.data.size = this.$filters.getReadableFileSize(file.size)
        },
        uploadFile(file){
            let formData = new FormData();
            formData.append(this.fileUploadType+'_file', file);

            this.$store.dispatch("changeLoaderValue", true)
            this.$http.post(this.absoluteUrl(this.uploadUrl), formData)
            .then((response) => {
                this.$store.dispatch("changeLoaderValue")
                if(response.data.success){
                    this.data.path = response.data.data
                    this.$emit('uploadSuccess', this.data)
                    this.resetForm()
                } else {
                    if (response.data.message) { 
                        this.showErrorMessage(response.data.message)
                    }
                }
            })
        }, 
        resetForm() {
            this.data = { imgSrc: "" }
        },
        showErrorMessage(message){
            this.errorMessage = message;
            setTimeout(() => {
                this.errorMessage = null
            }, 10000);
        }
    }
}
</script>

<style>

</style>